import { render, staticRenderFns } from "./PlanProgressBar.vue?vue&type=template&id=548271ed&"
import script from "./PlanProgressBar.vue?vue&type=script&lang=js&"
export * from "./PlanProgressBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports